<script>
// Component used only in fractal, not in sitecore
export default {
  name: 'CoveoController',
  mounted() {
    Coveo.SearchEndpoint.configureSampleEndpointV2();

    document.querySelectorAll('.js-coveo-interface').forEach((el) => {
      Coveo.init(el);
    });
  },
};
</script>
<template>
  <div />
</template>
